import api from "./core";

const basePath = "api/kiosk/Versions";

export default {
  async get(id) {
    return api.get(`${basePath}/${id}`);
  },
  async query(formId) {
    return api.post(`${basePath}/${formId}`);
  }
};
